import React from 'react'
import { SectionBox } from 'common/styleguide/SectionBox'
import { CalendarDate } from 'common/styleguide/CalendarDate'
import { RichListItem, RichListItemDetail as Detail } from 'common/styleguide/RichListItem'
import { ListMinimal } from 'common/styleguide/ListMinimal'
import { interfaceBase } from 'lib/styleguide/base.scss'
import styles from './Lists.scss'
import cx from 'classnames'

const flags = {
  italy: ['#139248', '#FFFFFF', '#CD2939'],
  belgium: ['#000000', '#F9DF50', '#EB283C'],
  france: ['#042494', '#FFFFFF', '#EB283C']
}

export class Lists extends React.PureComponent {
  render () {
    return (
      <div className={styles.Lists}>
        <h1>Rich Lists</h1>
        <div className={cx(styles.demoBox, interfaceBase)}>
          <SectionBox title='Basic List Items'>
            <RichListItem title='RichListItem 1'>
              <Detail>Basic Detail</Detail>
              <Detail icon='md-globe'>Icon Detail</Detail>
              <Detail wide>Extra-Width Detail is Longer</Detail>
              <Detail wide>Smaller</Detail>
            </RichListItem>
            <RichListItem title={<a href='#'>Link Heading</a>}>
              <Detail><a href='#'>Link Detail</a></Detail>
              <Detail icon='md-globe'>Icon Detail</Detail>
              <Detail wide>Extra-Width Detail</Detail>
              <Detail wide>Alignment maintained</Detail>
            </RichListItem>
          </SectionBox>

          <SectionBox title='List Items with Right Bumpers'>
            <Race
              name='Strade Bianche'
              href='https://en.wikipedia.org/wiki/Strade_Bianche'
              flag={flags.italy}
              country='Italy'
              countryLink='https://en.wikipedia.org/wiki/Italy'
              champion='Fabian Cancellara'
              since='2007' />
            <Race
              name='Gent–Wevelgem'
              href='https://en.wikipedia.org/wiki/Gent%E2%80%93Wevelgem'
              flag={flags.belgium}
              country='Belgium'
              countryLink='https://en.wikipedia.org/wiki/Belgium'
              champion='Eddy Merckx'
              since='1934' />
            <Race
              name='Paris–Roubaix'
              href='https://en.wikipedia.org/wiki/Paris%E2%80%93Roubaix'
              flag={flags.france}
              country='France'
              countryLink='https://en.wikipedia.org/wiki/France'
              champion='Roger De Vlaeminck'
              since='1896' />
          </SectionBox>

          <SectionBox title='List Items with Left Bumpers'>
            <Race
              name='Strade Bianche'
              href='https://en.wikipedia.org/wiki/Strade_Bianche'
              date='2018-03-03T00:01'
              country='Italy'
              countryLink='https://en.wikipedia.org/wiki/Italy'
              champion='Fabian Cancellara'
              since='2007' />
            <Race
              name='Gent–Wevelgem'
              href='https://en.wikipedia.org/wiki/Gent%E2%80%93Wevelgem'
              date='2018-03-25T00:01'
              country='Belgium'
              countryLink='https://en.wikipedia.org/wiki/Belgium'
              champion='Eddy Merckx'
              since='1934' />
            <Race
              name='Paris–Roubaix'
              href='https://en.wikipedia.org/wiki/Paris%E2%80%93Roubaix'
              date='2018-04-08T00:01'
              country='France'
              countryLink='https://en.wikipedia.org/wiki/France'
              champion='Roger De Vlaeminck'
              since='1896' />
          </SectionBox>

          <SectionBox title='List Items with Double Bumpers'>
            <Race
              name='Strade Bianche'
              href='https://en.wikipedia.org/wiki/Strade_Bianche'
              date='2018-03-03T00:01'
              flag={flags.italy}
              country='Italy'
              countryLink='https://en.wikipedia.org/wiki/Italy'
              champion='Fabian Cancellara'
              since='2007' />
            <Race
              name='Gent–Wevelgem'
              href='https://en.wikipedia.org/wiki/Gent%E2%80%93Wevelgem'
              date='2018-03-25T00:01'
              flag={flags.belgium}
              country='Belgium'
              countryLink='https://en.wikipedia.org/wiki/Belgium'
              champion='Eddy Merckx'
              since='1934' />
            <Race
              name='Paris–Roubaix'
              href='https://en.wikipedia.org/wiki/Paris%E2%80%93Roubaix'
              date='2018-04-08T00:01'
              flag={flags.france}
              country='France'
              countryLink='https://en.wikipedia.org/wiki/France'
              champion='Roger De Vlaeminck'
              since='1896' />
          </SectionBox>
        </div>

        <h1>Minimal Lists</h1>
        <h2>Standard Minimal List</h2>
        <ListMinimal style={{ maxWidth: '400px' }}>
          <Coffee n='Courier Coffee' l='800 ft' />
          <Coffee n='Heart Coffee' l='0.2 mi' />
          <Coffee n='Stumptown Coffee Roasters' l='0.5 mi' />
          <Coffee n='Simple Local Coffee' l='0.6 mi' />
          <Coffee n='Upper Left Roasters' l='1.2 mi' />
        </ListMinimal>
        <h2>Interactive Minimal List</h2>
        <ListMinimal interactive style={{ maxWidth: '400px' }}>
          <Coffee n='Courier Coffee' l='800 ft' />
          <Coffee n='Heart Coffee' l='0.2 mi' />
          <Coffee n='Stumptown Coffee Roasters' l='0.5 mi' />
          <Coffee n='Simple Local Coffee' l='0.6 mi' />
          <Coffee n='Upper Left Roasters' l='1.2 mi' />
        </ListMinimal>
      </div>
    )
  }
}

const Coffee = ({ n, l }) => (
  <li>
    <div>{n}</div>
    <div>{l}</div>
  </li>
)

const Race = ({ name, href, flag, date, country, countryLink, champion, since }) => (
  <RichListItem
    title={<a href={href} target='_blank' rel='noopener noreferrer'>{name}</a>}
    left={date && <CalendarDate date={new Date(date)} />}
    right={flag && <Flag c={flag} />}>
    <Detail icon='md-globe' tip='Country'><a href={countryLink} target='_blank' rel='noopener noreferrer'>{country}</a></Detail>
    <Detail icon='md-time' tip='Date First Held'>Since {since}</Detail>
    <Detail wide icon='md-trophy' tip='Most Wins'>{champion}</Detail>
  </RichListItem>
)

const Flag = ({ c }) => (
  <div style={{ height: 70, width: 70, display: 'flex', position: 'relative' }}>
    {c.map((color, index) => <div key={index} style={{ background: color, height: '100%', flex: '1' }}>&nbsp;</div>)}
  </div>
)
